import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import { Link } from "react-router-dom";
import SetupMenu from './SetupMenu';
import Spinner from 'react-bootstrap/Spinner';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
    COMPANY_LOGO_PRESETS,
    isCompanyLogoPreset,
    resolveCompanyLogoSrc,
} from "../../utils/companyLogo";

const SchoolInfo = () => {

    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [school, setSchool] = useState({});

    const [School_Code, setSchool_Code] = useState("");
    const [School_Name, setSchool_Name] = useState("");
    const [School_Address, setSchool_Address] = useState("");
    const [Schoole_Phone, setSchoole_Phone] = useState("");
    const [School_Fax, setSchool_Fax] = useState("");
    const [School_Email, setSchool_Email] = useState("");
    const [School_Website, setSchool_Website] = useState("");
    const [companyName, setCompanyName] = useState("");

    // photo for the print report logo
    const [showModal1, setShowModal1] = useState(false);
    const [image1, setImage1] = useState('');
    const [cropData1, setCropData1] = useState("");
    const [cropper1, setCropper1] = useState(null);
    const [imageSelected1, setImageSelected1] = useState(false);
    const [imgData1, setImageData1] = useState("");

    // photo for header logo
    const [showModal, setShowModal] = useState(false);
    const [image, setImage] = useState('');
    const [cropData, setCropData] = useState("");
    const [cropper, setCropper] = useState(null);
    const [imageSelected, setImageSelected] = useState(false);
    const [imgData, setImageData] = useState("");

    // photo for company logo (login screen)
    const [showModal2, setShowModal2] = useState(false);
    const [image2, setImage2] = useState('');
    const [cropData2, setCropData2] = useState("");
    const [cropper2, setCropper2] = useState(null);
    const [imageSelected2, setImageSelected2] = useState(false);
    const [imgData2, setImageData2] = useState("");
    // Built-in SVG preset filename selected for login branding (takes priority over crop until save)
    const [selectedCompanyPreset, setSelectedCompanyPreset] = useState("");

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setImageSelected(false);
    }
    const handleShowModal1 = () => setShowModal1(true);
    const handleCloseModal1 = () => {
        setShowModal1(false);
        setImageSelected1(false);
    }
    const handleShowModal2 = () => setShowModal2(true);
    const handleCloseModal2 = () => {
        setShowModal2(false);
        setImageSelected2(false);
    }

    const getLogoUrl = (fileName) => {
        if (!fileName) return "";
        if (isCompanyLogoPreset(fileName)) {
            return resolveCompanyLogoSrc(fileName);
        }
        return `${config.images}${fileName}?t=${Date.now()}`;
    };

    const selectCompanyPreset = (fileName) => {
        setSelectedCompanyPreset(fileName);
        setCropData2("");
        setImageData2("");
        setSchool((prev) => ({
            ...prev,
            companyLogo: fileName,
        }));
    };

    const toCleanBase64 = (dataUrl) => {
        if (!dataUrl) return "";
        const parts = dataUrl.split(",");
        return parts.length > 1 ? parts[1] : dataUrl;
    };

    useEffect(() => {
        document.title = "School Information";
        setPageLoading(true);

        axios({
            method: 'post',
            url: config.base_url + 'School/GetSchoolInfo',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
            }
        })
            .then(function (response) {
                if (response.data?.status_code === 1) {
                    const data = response.data;
                    setSchool(data);
                    setSchool_Code(data.School_Code || "");
                    setSchool_Name(data.School_Name || "");
                    setSchool_Address(data.School_Address || "");
                    setSchoole_Phone(data.Schoole_Phone || "");
                    setSchool_Fax(data.School_Fax || "");
                    setSchool_Email(data.School_Email || "");
                    setSchool_Website(data.School_Website || "");
                    setCompanyName(data.companyName || "");
                    if (isCompanyLogoPreset(data.companyLogo)) {
                        setSelectedCompanyPreset(data.companyLogo);
                    }
                } else {
                    toast.error(response.data?.status_message || "Unable to load school info.", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setPageLoading(false);
            })
            .catch(function () {
                setPageLoading(false);
                toast.error("Network error while loading school info.", {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
    }, [AccessKey, UserID, MemberType]);


    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            School_Code: School_Code,
            School_Name: School_Name,
            School_Address: School_Address,
            Schoole_Phone: Schoole_Phone,
            School_Fax: School_Fax,
            School_Email: School_Email,
            School_Website: School_Website,
            companyName: companyName,
        };

        // Only send logos when the user cropped a new image.
        if (cropData) {
            data.School_logo_large = cropData;
        }
        if (cropData1) {
            data.School_logo_small = cropData1;
        }
        if (cropData2) {
            data.companyLogo = cropData2;
        } else if (selectedCompanyPreset) {
            data.companyLogo = selectedCompanyPreset;
        }

        axios({
            method: 'post',
            url: config.base_url + 'School/UpdateSchoolInfo',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        })
            .then(function (response) {
                if (response.data.status_code == 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    // Keep local logo previews; refresh stored filenames after save.
                    if (cropData) {
                        setSchool((prev) => ({
                            ...prev,
                            School_logo_large: "L" + School_Code + ".jpg",
                        }));
                        setCropData("");
                    }
                    if (cropData1) {
                        setSchool((prev) => ({
                            ...prev,
                            School_logo_small: "S" + School_Code + ".jpg",
                        }));
                        setCropData1("");
                    }
                    if (cropData2) {
                        setSchool((prev) => ({
                            ...prev,
                            companyLogo: "C" + School_Code + ".jpg",
                        }));
                        setCropData2("");
                        setSelectedCompanyPreset("");
                    } else if (selectedCompanyPreset) {
                        setSchool((prev) => ({
                            ...prev,
                            companyLogo: selectedCompanyPreset,
                        }));
                    }
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
                setValidated(true);
            })
            .catch(function () {
                setLoading(false);
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
    }

    const onChange = (e) => {
        e.preventDefault();
        const files = e.target.files;
        if (!files || files.length === 0) {
            return;
        }
        setImageSelected(true);
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };

    const onChange1 = (e) => {
        e.preventDefault();
        const files = e.target.files;
        if (!files || files.length === 0) {
            return;
        }
        setImageSelected1(true);
        const reader = new FileReader();
        reader.onload = () => {
            setImage1(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };

    const onChange2 = (e) => {
        e.preventDefault();
        const files = e.target.files;
        if (!files || files.length === 0) {
            return;
        }
        setImageSelected2(true);
        const reader = new FileReader();
        reader.onload = () => {
            setImage2(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };

    const getCropData = () => {
        if (cropper) {
            const cropped = cropper.getCroppedCanvas().toDataURL();
            setCropData(toCleanBase64(cropped));
            setImageData(cropped);
        }
        handleCloseModal();
    };

    const getCropData1 = () => {
        if (cropper1) {
            const cropped = cropper1.getCroppedCanvas().toDataURL();
            setCropData1(toCleanBase64(cropped));
            setImageData1(cropped);
        }
        handleCloseModal1();
    };

    const getCropData2 = () => {
        if (cropper2) {
            const cropped = cropper2.getCroppedCanvas().toDataURL();
            setCropData2(toCleanBase64(cropped));
            setImageData2(cropped);
            setSelectedCompanyPreset("");
        }
        handleCloseModal2();
    };

    const renderButtons = () => {
        if (imageSelected === true) {
            return (
                <div className="modal-footer justify-content-center">
                    <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal}>Close</button>
                    <button type="button" className="button button-primary" onClick={getCropData}>Save Photo</button>
                </div>
            );
        }
        return (
            <div className="modal-footer justify-content-center">
                <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal}>Close</button>
            </div>
        );
    };

    const renderButtons1 = () => {
        if (imageSelected1 === true) {
            return (
                <div className="modal-footer justify-content-center">
                    <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal1}>Close</button>
                    <button type="button" className="button button-primary" onClick={getCropData1}>Save Photo</button>
                </div>
            );
        }
        return (
            <div className="modal-footer justify-content-center">
                <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal1}>Close</button>
            </div>
        );
    };

    const renderButtons2 = () => {
        if (imageSelected2 === true) {
            return (
                <div className="modal-footer justify-content-center">
                    <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal2}>Close</button>
                    <button type="button" className="button button-primary" onClick={getCropData2}>Save Photo</button>
                </div>
            );
        }
        return (
            <div className="modal-footer justify-content-center">
                <button type="button" className="button button-outline-primary me-2" onClick={handleCloseModal2}>Close</button>
            </div>
        );
    };

    return (
        <>
            <SetupMenu />
            <ToastContainer />
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Header Logo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upload-photo-wrap">
                        {imageSelected ? (
                            <Cropper
                                zoomTo={0.5}
                                aspectRatio={19 / 6}
                                preview=".img-preview"
                                src={image}
                                dragMode="move"
                                viewMode={2}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropper(instance);
                                }}
                                guides={true}
                            />
                        ) : (
                            <div className="choose-photo">
                                <label htmlFor="ChoosePhoto">
                                    <i className="ri-upload-cloud-line"></i>
                                    <span>Browse Photo</span>
                                    <input id="ChoosePhoto" accept="image/jpeg,image/png" type="file" onChange={onChange} />
                                </label>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                {renderButtons()}
            </Modal>

            <Modal show={showModal1} onHide={handleCloseModal1}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Print Logo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upload-photo-wrap">
                        {imageSelected1 ? (
                            <Cropper
                                zoomTo={0.5}
                                preview=".img-preview"
                                src={image1}
                                dragMode="move"
                                viewMode={2}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropper1(instance);
                                }}
                                guides={true}
                            />
                        ) : (
                            <div className="choose-photo">
                                <label htmlFor="ChoosePhoto1">
                                    <i className="ri-upload-cloud-line"></i>
                                    <span>Browse Photo</span>
                                    <input id="ChoosePhoto1" accept="image/jpeg,image/png" type="file" onChange={onChange1} />
                                </label>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                {renderButtons1()}
            </Modal>

            <Modal show={showModal2} onHide={handleCloseModal2}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Company Logo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upload-photo-wrap">
                        {imageSelected2 ? (
                            <Cropper
                                zoomTo={0.5}
                                preview=".img-preview"
                                src={image2}
                                dragMode="move"
                                viewMode={2}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropper2(instance);
                                }}
                                guides={true}
                            />
                        ) : (
                            <div className="choose-photo">
                                <label htmlFor="ChoosePhoto2">
                                    <i className="ri-upload-cloud-line"></i>
                                    <span>Browse Photo</span>
                                    <input id="ChoosePhoto2" accept="image/jpeg,image/png" type="file" onChange={onChange2} />
                                </label>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                {renderButtons2()}
            </Modal>

            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/Setup/SetupDashboard">Setup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">School Info</li>
                                </ol>
                            </nav>
                            <div className="page-title">School Information</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    {pageLoading ? (
                        <div className="text-center p-5">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : (
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className="row gy-3 align-items-center">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body p-md-4">
                                        <div className="row gy-3 align-items-center">
                                            <div className="col-md-2 col-sm-4">
                                                <div className="form-group">
                                                    <label>School Code:</label>
                                                    <input
                                                        type="text"
                                                        name="School_Code"
                                                        value={School_Code}
                                                        onChange={(e) => setSchool_Code(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-10 col-sm-8">
                                                <div className="form-group">
                                                    <label>School Name:</label>
                                                    <input
                                                        type="text"
                                                        name="School_Name"
                                                        value={School_Name}
                                                        onChange={(e) => setSchool_Name(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Address:</label>
                                                    <textarea
                                                        rows="2"
                                                        cols="20"
                                                        name="School_Address"
                                                        value={School_Address}
                                                        onChange={(e) => setSchool_Address(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-group">
                                                    <label>Phone:</label>
                                                    <input
                                                        type="text"
                                                        name="Schoole_Phone"
                                                        value={Schoole_Phone}
                                                        onChange={(e) => setSchoole_Phone(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-group">
                                                    <label>Fax No:</label>
                                                    <input
                                                        type="text"
                                                        name="School_Fax"
                                                        value={School_Fax}
                                                        onChange={(e) => setSchool_Fax(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-group">
                                                    <label>Email:</label>
                                                    <input
                                                        type="email"
                                                        name="School_Email"
                                                        value={School_Email}
                                                        onChange={(e) => setSchool_Email(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <div className="form-group">
                                                    <label>Website:</label>
                                                    <input
                                                        type="text"
                                                        name="School_Website"
                                                        value={School_Website}
                                                        onChange={(e) => setSchool_Website(e.target.value)}
                                                        className="form-control"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <div className="form-group">
                                                    <label>Company Name:</label>
                                                    <input
                                                        type="text"
                                                        name="companyName"
                                                        value={companyName}
                                                        onChange={(e) => setCompanyName(e.target.value)}
                                                        className="form-control"
                                                        maxLength={500}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 text-center">
                                <div className="card">
                                    <div className="card-body p-md-4">
                                        <div className="row gy-3 align-items-md-end">
                                            <div className="col-md-3 col-sm-6">
                                                <div className="form-group">
                                                    <label>Header Logo: 210px × 40px</label>
                                                </div>
                                                <div className="d-block mt-3 m-auto">
                                                    {imgData ? (
                                                        <img className="mb-3" src={imgData} alt="Header logo preview" style={{ width: "150px" }} />
                                                    ) : school.School_logo_large ? (
                                                        <img className="mb-3" src={getLogoUrl(school.School_logo_large)} alt="Header logo" style={{ width: "150px" }} />
                                                    ) : (
                                                        <div className="mb-3 text-muted small">No header logo uploaded</div>
                                                    )}
                                                </div>
                                                <button type="button" onClick={handleShowModal} className="mb-2 button button-small">
                                                    Choose Logo for Header
                                                </button>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <div className="form-group">
                                                    <label>Print Report Logo</label>
                                                </div>
                                                <div className="d-block mt-3 m-auto">
                                                    {imgData1 ? (
                                                        <img className="mb-3" src={imgData1} alt="Print logo preview" style={{ width: "150px" }} />
                                                    ) : school.School_logo_small ? (
                                                        <img className="mb-3" src={getLogoUrl(school.School_logo_small)} alt="Print logo" style={{ width: "150px" }} />
                                                    ) : (
                                                        <div className="mb-3 text-muted small">No print logo uploaded</div>
                                                    )}
                                                </div>
                                                <button type="button" onClick={handleShowModal1} className="mb-2 button button-small">
                                                    Choose Logo for Print Report
                                                </button>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <div className="form-group">
                                                    <label>Company Logo (Login Screen)</label>
                                                </div>
                                                <div className="d-block mt-3 m-auto">
                                                    {imgData2 ? (
                                                        <img className="mb-3" src={imgData2} alt="Company logo preview" style={{ width: "150px" }} />
                                                    ) : school.companyLogo ? (
                                                        <img className="mb-3" src={getLogoUrl(school.companyLogo)} alt="Company logo" style={{ width: "150px" }} />
                                                    ) : (
                                                        <div className="mb-3 text-muted small">Default: Plus Minus Systems</div>
                                                    )}
                                                </div>
                                                <div className="d-flex flex-wrap justify-content-center gap-2 mb-2">
                                                    {COMPANY_LOGO_PRESETS.map((preset) => (
                                                        <button
                                                            key={preset.fileName}
                                                            type="button"
                                                            className={`button button-small ${(selectedCompanyPreset || school.companyLogo) === preset.fileName ? "button-primary" : ""}`}
                                                            onClick={() => selectCompanyPreset(preset.fileName)}
                                                            title={preset.label}
                                                        >
                                                            <img src={preset.src} alt={preset.label} style={{ height: "28px", maxWidth: "90px" }} />
                                                        </button>
                                                    ))}
                                                </div>
                                                <button type="button" onClick={handleShowModal2} className="mb-2 button button-small">
                                                    Upload Custom Logo
                                                </button>
                                            </div>
                                            <div className="col-md-3 col-sm-12">
                                                {loading ? (
                                                    <Spinner animation="border" role="status"></Spinner>
                                                ) : (
                                                    <button type="submit" className="w-100 button button-primary">Update Information</button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                    )}
                </div>
            </div>
        </>
    );
}

export default SchoolInfo;
